import { JSXElementConstructor, ReactElement, ReactNode, createElement } from "react";
import { useTranslation } from "react-i18next";

function HotelStatusTooltip({
    status,
    children,
}: {
    children?: ReactNode;
    status: {
        text: string;
        bg: string;
        component: () => JSXElementConstructor<{
            fontSize?: number;
            color?: string;
        }>;
        tooltip: { title: string; description: string; className?: string; descriptionComp?: ReactElement<{}> };
    };
}) {
    const { t } = useTranslation();
    return (
        <div className=" text-sm  !p-0 flex flex-col   gap-1 ">
            <div className="flex items-center gap-1 p-2   " style={{ color: status.text, backgroundColor: status.bg }}>
                {createElement(status.component(), {
                    fontSize: 14,
                    color: status.text,
                })}
                {t(status.tooltip.title || "")}
            </div>
            <span className=" p-2 pl-3 ">{status.tooltip.descriptionComp || t(status.tooltip.description || "")}</span>
            {children}
        </div>
    );
}

export default HotelStatusTooltip;
